const productLayeringSlider = document.querySelector('.product-layering__slider');
new BlazeSlider(productLayeringSlider, {
  all: {
    slidesToShow: 1,
    slidesToScroll: 1,
    loop: false,
  },
  '(min-width: 768px)': {
    slidesToShow: 2,
    slideGap: '40px',
  },
  '(min-width: 991px)': {
    slidesToShow: 3,
  },
});

// Verify if there are any product layerings available
const productLayeringItem = document.querySelector('.product-layering__item');
if (!productLayeringItem) {
  const productLayering = document.querySelector('product-layering');
  productLayering.classList.add('hidden');
}